import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import { Jeton } from "./type";

export const jetonLoader: LoaderFunction = async (args) => {
  if (args.params.id === "new") {
    return new Promise((res) => res(Result.newResult()));
  }
  const result = await axiosApi.get<Result<Jeton>>(
    "/api/jetons/jetons/" + args.params.id
  );
  return result.data;
};
